import React, { createContext, useState, useContext, useEffect } from "react";
import authService from "../services/authService";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const fetchUser = async (t) => {
      try {
        const data = await authService.getUser(t);
        const first_name = data?.firstName ? data.firstName : "";
        const isSetupComplete = data?.isSetupComplete;
        const phone_number = data.phoneNumber;
        const custom_function = data.customFunction;
        const schedule_functions = data.scheduleFunctions;
        const remaining_minutes = data.remainingMinutes;
        const storedUser = localStorage.getItem("user");
        const userDetails = JSON.parse(storedUser);
        if (storedUser) {
          setUser({
            first_name,
            phone_number,
            custom_function,
            schedule_functions,
            remaining_minutes,
            isSetupComplete,
            ...userDetails,
          });
        }
      } catch (error) {
        console.error("Failed to fetch user data:", error);
      }
    };

    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      setToken(storedToken);
      fetchUser(storedToken);
    }
  }, [token]);

  const login = async (userData) => {
    try {
      setUser(userData);
      setToken(userData.access_token);
      localStorage.setItem("user", JSON.stringify(userData));
      localStorage.setItem("token", userData.access_token);

      const data = await authService.getUser(userData.access_token);
      const phone_number = data.phoneNumber;
      setUser((prevUser) => ({ ...prevUser, phone_number }));
    } catch (error) {
      console.error("Failed to log in:", error);
    }
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem("user");
    localStorage.removeItem("token");
  };

  return (
    <UserContext.Provider value={{ user, token, login, logout }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);

export const useAuth = () => {
  const { user, token } = useContext(UserContext);
  const storedToken = localStorage.getItem("token"); // Ensure consistent key usage
  return !!user || !!storedToken || !!token; // Return true if user or token exists
};
